<template>
  <list-card
    :items="items"
    :entity-type="entityType"
    :list-actions="listActions"
    :group-actions="groupActions"
    :is-filter-active="isFilterActive"
    :sorting="sorting"
    :current-sort-by="currentSortId"
    title="Types"
    @click:sort="handleSort"
    @click:filter-icon="handleFilterOpen"
  >
    <template #item="{select,index, ...props}">
      <type-list-item
        v-testid="`type-list-item-${index}`"
        v-bind="props"
        :actions="getItemActions(props.item)"
        :to="getItemRoute(props.item)"
        @select="select"
      />
    </template>
  </list-card>
</template>

<script>
import ListCard from '@/components/list-card';
import TypeListItem from './TypeListItem';
import { useTypeListActions } from './listActions';
import groupActions from './groupActions';

import { computed, onMounted, ref } from '@vue/composition-api';

import { useSortBy } from '@/compositions/sortBy';
import { useTypeMenu } from '@/modules/object-types/compositions/typeMenu';
import { useTypes } from '@/modules/object-types/compositions/types';
import sortingMenu from './sortingMenu';
import { useGeotagFilters } from '@/modules/geotags/compositions/geotag-filters';
import { useFilter } from '@/compositions/filter';
import { TYPE_LIST_FILTER } from '@/modules/object-types/compositions/type-filters';
import { SearchEntityEnum } from '@/compositions/globalSearch';
import ObjectListItem from '@/modules/objects/ui/object-list/ObjectListItem.vue';

export default {
  name: 'Types',
  components: {
    ObjectListItem,
    ListCard,
    TypeListItem
  },

  setup(props, { root }) {
    const { list, load } = useTypes();

    const getItemRoute = item => ({
      name: 'type_card',
      params: {
        typeId: item.id
      },
      query: root.$route.query
    });

    const getItemActions = entity => {
      return useTypeMenu({ entity });
    };

    const keyword = computed(() => {
      return root.$route?.query?.keyword;
    });

    const searchedList = computed(() => {
      return keyword.value
        ? list.value.filter(i => i.title.includes(keyword.value))
        : list.value;
    });

    const filters = useGeotagFilters();

    const {
      filteredItems,
      setFilter,
      currentFilter,
      isFilterActive,
      handleFilterOpen
    } = useFilter(searchedList, filters, TYPE_LIST_FILTER);

    const { sortedItems, currentSortId, handleSort } = useSortBy(
      filteredItems,
      sortingMenu,
      'type'
    );

    const { listActions } = useTypeListActions();

    onMounted(() => {
      load();
    });

    return {
      getItemRoute,
      items: sortedItems,
      getItemActions,
      listActions,
      groupActions,
      sorting: sortingMenu,
      currentSortId,
      handleSort,
      list,
      setFilter,
      currentFilter,
      isFilterActive,
      handleFilterOpen,
      entityType: SearchEntityEnum.type
    };
  }
};
</script>

<style></style>
